import closeLoader from './close-loader.action';

export default closeLoader;
